import { render } from "./NavigationLayout.vue?vue&type=template&id=4900f30d&scoped=true"
import script from "./NavigationLayout.vue?vue&type=script&lang=js"
export * from "./NavigationLayout.vue?vue&type=script&lang=js"

import "./NavigationLayout.vue?vue&type=style&index=0&id=4900f30d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4900f30d"]])

export default __exports__